// removed by extract-text-webpack-plugin
module.exports = {"container":"container_qzg88","row":"row_3sonM","gap":"gap_3Jp3F","gap_grow":"gap_grow_2re_R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/style.scss
// module id = 525
// module chunks = 0